
const getOrgId = (clientSessionData) => clientSessionData.get('id');
const getUrlToken = (clientSessionData) => clientSessionData.get('urlToken');

export {
	getOrgId,
	getUrlToken
}